import type { AxiosResponse } from "axios";

import { AxiosInstance } from "api";

interface Roles {
  isBillingAdmin: boolean;
  isPartner: boolean;
  isPhysician: boolean;
}

const prefixString = ({ isBillingAdmin, isPartner, isPhysician }: Roles) => {
  if (isBillingAdmin) return "billing_admins";
  if (isPartner) return "clinic_partners";
  if (isPhysician) return "physicians";
  return "therapists";
};

interface Args extends Roles {
  profileId: number;
}

export const completeOnboarding = ({
  profileId,
  isBillingAdmin,
  isPartner,
  isPhysician,
}: Args): Promise<AxiosResponse> =>
  AxiosInstance.post(`/${prefixString({ isBillingAdmin, isPartner, isPhysician })}/${profileId}/complete_onboarding`);
